module.exports = __webpack_public_path__ + "img/usage-5.c51d4ffa.png";